export default "__VITE_ASSET__B9QQhu9a__"